<template>
  <div class="other-documentation">
    <section>
      <h1>API Partners</h1>
      <p>
        This section of the portal is for integration partners building to the
        Smart Residential.
      </p>
    </section>

    <section class="api-partners">
      <div
        class="api-partners-item mt-8"
        v-for="(item, index) in docList"
        :key="index"
      >
        <h3>{{ item.title }}</h3>

        <router-link
          :to="item.linkOne.url"
          class="grey--text text--darken-2 header-link mt-2"
          >{{ item.linkOne.name }}</router-link
        >

        <router-link
          v-if="item.linkTwo"
          :to="item.linkTwo.url"
          class="grey--text text--darken-2 header-link mt-8"
          >{{ item.linkTwo.name }}</router-link
        >
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data: () => {
    return {
      docList: [
        {
          title: 'Integration Certification',
          linkOne: {
            name: 'Partner API Call Limits',
            url: '/partner-api-call-limits',
          },
          // linkTwo: {
          //   name: 'API Integration Certification Process',
          //   url: '/api-integration-certification',
          // },
        },
        {
          title: 'Guideline',
          linkOne: {
            name: 'Yale Marketing and Branding Guidelines',
            url: '/market-brand-guidelines',
          },
          linkTwo: {
            name: 'Re-Onboard Development Portal',
            url: '/reonboard-portal-process',
          },
        },
      ],
    };
  },
};
</script>

<style lang="scss">
.other-documentation {
  max-width: 1200px;
  margin: 0 auto;
  padding: 4.5rem 4rem 1rem 4rem;

  .api-partners {
    display: flex;
    justify-content: space-between;

    .api-partners-item {
      display: flex;
      flex-direction: column;
    }
  }

  ul {
    margin-top: 5px;
    margin-bottom: 5px;
    padding-inline-start: 40px;
  }

  li {
    margin-top: 5px;
    margin-bottom: 5px;
    word-wrap: break-word;
  }
  p {
    margin-top: 15px;
    margin-bottom: 15px;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-top: 18px;
  }
}

@media only screen and (max-width: 600px) {
  .other-documentation {
    padding: 2rem 2rem 1rem 2rem;

    .api-partners {
      display: flex;
      flex-direction: column;
      margin-top: 15px !important;
    }

    ul {
      padding-inline-start: 20px;
    }
  }
}
</style>
